export default __webpack_public_path__ + "static/media/6_Osmos_Tortora-Ribbed-60x120_Tortora_120x120 Matt.7936bcae.jpg";